import { useQuery } from 'react-query';

// app
import { appAxios } from 'lib/app';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';
import { BRANDS } from 'lib/app/queryKeys';

// Edge Springboot API
// using v2 for new brands endpoint to get sub-departments
export const useGetBrands = (version = 'v1') => {
  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.admin.queries.useGetFacilityGroups',
    };

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  return useQuery(
    [BRANDS, version],
    async () => {
      const result = await appAxios.get(`/${version}/brands`);
      return result?.data?.content?.sort((a, b) => a.name.localeCompare(b.name)) || [];
    },
    {
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
